// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.btn[data-v-08a5e95b] {
  background-color: #ececec;
  margin: 0 0.25rem 0.25rem;
}
.image-map-view[data-v-08a5e95b] {
  overflow:hidden;
  width:100%;
  height:100%;
  position:relative;
}
map area[data-v-08a5e95b] {
  cursor: pointer;
}
.zoomButtons[data-v-08a5e95b] {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 0.5rem;
}
.zoomButtons button i.fa[data-v-08a5e95b] {
  margin-right: 0;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
